// 使用 Vue CLI 的环境变量配置
const isDevelopment = process.env.NODE_ENV === 'development'
const isProduction = process.env.NODE_ENV === 'production'

export default {
    debug: isDevelopment,
    api_url_domain: process.env.VUE_APP_API_URL || (isDevelopment ? "http://192.168.5.195:8031" : "https://chezhibao.ltd"),
    access_control_allow_origin: process.env.VUE_APP_CORS_ORIGIN || (isDevelopment ? 'http://192.168.5.195:8031' : 'https://chezhibao.ltd'),
    environment: process.env.NODE_ENV,
    isProduction: isProduction,
    isDevelopment: isDevelopment
}



